import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=737d2f05&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=737d2f05&prod&lang=css"
import style1 from "./OrderConfirm.vue?vue&type=style&index=1&id=737d2f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d2f05",
  null
  
)

export default component.exports